export default {
  GET_REVIEW_REQUESTS: 'GET_REVIEW_REQUESTS',
  STOP_REVIEW_REQUEST: 'STOP_REVIEW_REQUEST',
  RESEND_REVIEW_REQUEST: 'RESEND_REVIEW_REQUEST'
}
